import DNAView from 'molbio/maps/circular/DNAView';
import {
  HomologyAwareFragmentResultData,
  getHomologyAwareFragmentResultData,
} from 'molbio/maps/circular/HomologyUtil';

export default class HomologyRegionDNAView extends DNAView {
  static initClass(): void {
    this.prototype.className = 'homologyRegionDNA';
  }

  getPiecesData(): Array<HomologyAwareFragmentResultData> {
    return getHomologyAwareFragmentResultData(this._sequence, this.getOuterRadius(), (basePair: number) =>
      this.basePairToAngle(basePair)
    );
  }
}

HomologyRegionDNAView.initClass();
